<template>
    <div :class="[ absolute ? 'block-ui-n' : '' ]">
        <div class="spinner-n" :class="[ absolute ? 'absolute-n' : 'relative-n' ]">
            <div class="double-bounce1-n" :style="{ 'background-color': backgroundColor }"></div>
            <div class="double-bounce2-n" :style="{ 'background-color': backgroundColor }"></div>
        </div>
    </div>
</template>

<script>
export default {

    props: {

        absolute: {

            type: Boolean,
            default: true,

        },

    },

    data() {

        return {

            backgroundColor: '#fff',

        };

    },

    mounted() {

        const colors = $.parseJSON(localStorage.getItem('colors'));

        if (colors) {

            this.backgroundColor = colors.primary;

        }

    },

};
</script>
